(() => {
  if (window.NookAccordionMotion || !Element.prototype.animate) return;
  const selector = '.ns-faq__item, .ns-product-details__accordion';
  const controllers = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const timing = { duration: 320, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'both' };

  class AccordionMotion {
    constructor(details) {
      this.details = details;
      this.summary = details.querySelector(':scope > summary');
      this.content = this.summary?.nextElementSibling;
      this.targetOpen = details.open;
      this.animation = null;
      this.contentAnimation = null;
      this.savedHeight = details.style.height;
      this.savedOverflow = details.style.overflow;
      if (!this.summary || !this.content) return;
      this.summary.addEventListener('click', (event) => {
        if (event.target.closest('a') || reducedMotion.matches) return;
        event.preventDefault();
        this.toggle();
      });
      details.addEventListener('toggle', () => {
        if (!this.animation) this.targetOpen = details.open;
      });
    }

    toggle() {
      const details = this.details;
      const startHeight = details.getBoundingClientRect().height;
      const wasClosed = !details.open;
      const contentOpacity = wasClosed ? 0 : Number(getComputedStyle(this.content).opacity);
      const contentTransform = wasClosed ? 'translateY(-4px)' : getComputedStyle(this.content).transform;
      const opening = !this.targetOpen;
      this.targetOpen = opening;

      if (this.animation) {
        this.animation.onfinish = null;
        this.animation.cancel();
      }
      this.contentAnimation?.cancel();
      details.open = true;
      details.style.height = 'auto';
      const styles = getComputedStyle(details);
      const borderAndPadding = ['borderTopWidth', 'borderBottomWidth', 'paddingTop', 'paddingBottom']
        .reduce((total, key) => total + (parseFloat(styles[key]) || 0), 0);
      const endHeight = opening
        ? details.getBoundingClientRect().height
        : this.summary.getBoundingClientRect().height + borderAndPadding;
      details.style.height = startHeight + 'px';
      details.style.overflow = 'hidden';
      details.dataset.nsMotionState = opening ? 'opening' : 'closing';

      this.contentAnimation = this.content.animate(
        [
          { opacity: contentOpacity, transform: contentTransform },
          { opacity: opening ? 1 : 0, transform: opening ? 'translateY(0)' : 'translateY(-4px)' }
        ],
        { ...timing, duration: opening ? 280 : 200 }
      );
      const animation = details.animate(
        [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
        timing
      );
      this.animation = animation;
      animation.onfinish = () => {
        if (this.animation === animation) this.finish();
      };
    }

    finish(open = this.targetOpen) {
      this.targetOpen = open;
      this.details.open = open;
      if (this.animation) {
        this.animation.onfinish = null;
        this.animation.cancel();
      }
      this.contentAnimation?.cancel();
      this.animation = null;
      this.contentAnimation = null;
      this.details.style.height = this.savedHeight;
      this.details.style.overflow = this.savedOverflow;
      delete this.details.dataset.nsMotionState;
    }
  }

  function init(root = document) {
    const details = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) details.unshift(root);
    details.forEach((element) => {
      if (!controllers.has(element)) controllers.set(element, new AccordionMotion(element));
    });
  }

  function finishRunning(root = document) {
    root.querySelectorAll(selector).forEach((element) => {
      const controller = controllers.get(element);
      if (controller?.animation) controller.finish();
    });
  }

  window.NookAccordionMotion = { init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => finishRunning(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.closest(selector);
    if (details) {
      const controller = controllers.get(details);
      if (controller) controller.finish(true);
      else details.open = true;
    }
  });
  window.addEventListener('resize', () => finishRunning(), { passive: true });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) finishRunning();
  });
})();
